module.exports = __webpack_public_path__ + "img/icon-efecty-simple.9fe9941d.svg";